<div class="info-box" *ngIf="info">
  <!-- <p>
    Price:<br>
    {{priceData.value}} {{priceData.currency}}
  </p>
  <p>
    Min price:<br>
    {{priceData.minValue}} {{priceData.currency}}
  </p>
  <p>
    Min turnover:<br>
    {{priceData.minValue * lineItem.displayUnitQuantity}} {{priceData.currency}}
  </p>
  <p>
    Net profit:<br>
    {{priceData.value * lineItem.displayUnitQuantity - priceData.minValue * lineItem.displayUnitQuantity}} {{priceData.currency}}
  </p>
  <p>
    Net profit %:<br>
    {{100 * priceData.minValue / priceData.value}} {{priceData.currency}}
  </p>     -->
  <table>
    <tr *ngIf="info.incomplete" style="color: darkred"><td colspan="100">WARNING: Profit calc incomplete</td></tr>
    <tr *ngIf="info.unit">
      <td>Unit</td><td>{{info.unit}}</td>
    </tr>
    <tr *ngIf="info.price">
      <td>Price</td><td>{{info.price | number : '1.2-2'}} {{info.currency}}</td>
    </tr>
    <tr>
      <td>Turnover</td><td>{{info.turnover | number : '1.2-2'}} {{info.currency}}</td>
    </tr>
    <!-- <tr *ngIf="info.minPrice">
      <td>Min price</td><td>{{info.minPrice | number : '1.2-2'}} {{info.currency}}</td>
    </tr> -->
    <tr>
      <td>Min turnover</td><td>{{info.minTurnover | number : '1.2-2'}} {{info.currency}}</td>
    </tr>
    <tr>
      <td>Net profit</td><td>{{info.netProfit | number : '1.2-2'}} {{info.currency}}</td>
    </tr>
    <tr>
      <td>Net profit (%)</td><td>{{info.profitPercent | number : '1.0-2'}} %</td>
    </tr>
  </table>
</div>
